export const validateName = newName => {
  let error = '';
  if (!newName) {
    error = 'Collection name is required';
  } else if (newName.length > 18) {
    error = 'Collection name should be less than or equal to 18 letters';
  } else if (/[^a-z0-9 ]/i.test(newName)) {
    error = 'Collection name must contain only alphanumeric characters and spaces';
  }
  return error;
};
export const getPlaceholder = isMobileView => isMobileView ? 'Name your collection link' : 'Enter a name for your size collection link';
export const TEXT = `Give your size collection link a simple name so you can easily reference it
  to keep track of your submissions. For example, if you're trying to collect apparel sizes from
  a particular team, you could name your form based on that team's name (e.g., “Marketing Team”).`;